export const buildCheckoutRecoveryReservationPayload = (data) => {
    const request = data.request || {}
    const form = data.form || {}

    return {
        step: 'PAYMENT',
        ...request,
        ...form,
        agreements: (form.agreements || []).map((agreement) => ({
            ...agreement,
            key: String(agreement.id),
        })),
        offer: data.offer,
        selectedInsurance: data.selectedInsurance,
        selectedParkingOffer: data.selectedParkingOffer,
        selectedParkingAirport: data.selectedParkingAirport,
        insuranceOffers: data.insuranceOffers,
        payment_method: data.paymentMethod,
        expected_offer_price: data.price.current,
        useCashbackForPay: data.useCashbackForPay,
        promotionCodes: data.promotionCodes,
        earnedCashbackAmount: data.earnedCashbackAmount,
        checkout_recovery: request.checkout_recovery,
        udds_snapshot: request.udds_snapshot,
    }
}
